import i18n from '../../i18n';

export default {
  optional: ' (اختیاری) ',
  description: 'توضیحات',
  hint: 'راهنما',
  addDescription: '+ افزودن توضیحات',
  justFloatNumberPermitted: 'فقط اعداد صحیح یا اعشاری مجاز است',
  emptyChoicesError: 'نمی‌تواند خالی باشد',
  invalidINID: 'کدملی وارد شده معتبر نیست',
  add: 'افزودن',
  done: 'ثبت',
  search: 'جستجو',
  selectAValue: 'مقداری را انتخاب کنید',
  close: 'بستن',
  hour: 'ساعت',

  remainingCharacters(length: string) {
    return i18n.t('remainingCharacters', { ns: 'survey', length });
  },
  invalidSize(maxSize: string) {
    return i18n.t('invalidSize', { ns: 'survey', maxSize: maxSize });
  },
  invalidType(type: string) {
    return i18n.t('invalidType', { ns: 'survey', type });
  },
};
